import React, { useContext, useState } from 'react'
import { UserContext } from '../App';
import { Navigate, useNavigate } from 'react-router-dom';


export const Logout = () => {
      const { setAuth, setUser } = useContext(UserContext)
      const navigate = useNavigate()
      setAuth(false)
      setUser('')
      localStorage.setItem('token', '');
      navigate('/')
      window.location.reload()
}